module.exports = __webpack_public_path__ + "img/align-vertical-center-02.cf311a29.svg";